import * as Types from '../../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type DeleteWorkLocationAssignmentMutationVariables = Types.Exact<{
  input: Types.DeleteWorkLocationAssignmentInput
}>

export type DeleteWorkLocationAssignmentMutation = {
  __typename?: 'Mutation'
  deleteWorkLocationAssignment?: {
    __typename?: 'DeleteWorkLocationAssignmentPayload'
    deleted: boolean
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const DeleteWorkLocationAssignmentDocument = `
    mutation DeleteWorkLocationAssignment($input: DeleteWorkLocationAssignmentInput!) {
  deleteWorkLocationAssignment(input: $input) {
    deleted
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useDeleteWorkLocationAssignmentMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteWorkLocationAssignmentMutation,
    TError,
    DeleteWorkLocationAssignmentMutationVariables,
    TContext
  >
) =>
  useMutation<
    DeleteWorkLocationAssignmentMutation,
    TError,
    DeleteWorkLocationAssignmentMutationVariables,
    TContext
  >(
    ['DeleteWorkLocationAssignment'],
    (variables?: DeleteWorkLocationAssignmentMutationVariables) =>
      fetchGql<DeleteWorkLocationAssignmentMutation, DeleteWorkLocationAssignmentMutationVariables>(
        DeleteWorkLocationAssignmentDocument,
        variables
      )(),
    options
  )
